'use es6';

import fromRefinementFilter from './fromRefinementFilter';
const tryAddRefinement = (operator, field, filter) => {
  const refinement = fromRefinementFilter(field, filter);
  return refinement ? operator.set('refinement', refinement) : operator;
};
const fromPrivacyConsentOperation = (Operator, field, filter) => {
  const operator = Operator.of(field, filter.privacyName);
  return tryAddRefinement(operator, field, filter);
};
export { fromPrivacyConsentOperation };